module.exports = __webpack_public_path__ + "img/bf3e13100cc0bed60c2ffd356049ee06.png";